import { render, staticRenderFns } from "./StrategyRecord.vue?vue&type=template&id=7c7cb186&scoped=true"
import script from "./StrategyRecord.vue?vue&type=script&lang=js"
export * from "./StrategyRecord.vue?vue&type=script&lang=js"
import style0 from "./StrategyRecord.vue?vue&type=style&index=0&id=7c7cb186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7cb186",
  null
  
)

export default component.exports